import { useMemo } from "react";
import { Box } from "@mantine/core";
import { ReportPhotoContent, type OrganMapPhoto } from "./ReportPhotoContent";
import { getReportMediaFrameHeight } from "./reportOrganMapLayout";

interface Props {
  photos: OrganMapPhoto[];
  width: string;
}

export function AddendumReportPhotoRow({ photos, width }: Props) {
  const layout = useMemo(() => {
    const height =
      photos.length > 1 ? getReportMediaFrameHeight(width, []) : undefined;
    return {
      width,
      height,
      frameHeight: height,
      maxWidth: "100%",
      objectPosition: height ? "center bottom" : undefined,
    };
  }, [photos.length, width]);
  return (
    <Box
      data-addendum-photo-row
      mt={8}
      style={{
        display: "flex",
        gap: 8,
        justifyContent: "center",
        alignItems: "flex-start",
      }}
    >
      {photos.map((photo) => (
        <Box
          key={photo.image.id}
          data-report-media-item="photo"
          style={{ flex: `0 0 ${width}`, maxWidth: "100%" }}
        >
          <ReportPhotoContent {...photo} layout={layout} />
        </Box>
      ))}
    </Box>
  );
}
